import OBase from './OBase';

import * as Geometry from '../geometry';

export default class BooleanToggle extends OBase {
  update () {
    let pOutput = this.getGenericObjectOutput('Boolean Toggle');

    let value = this.ghGeometryObject.value;

    var outTree = new Geometry.DataTree();
    outTree.add(value, new Geometry.GHPath(0));
    pOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/BooleanToggle.js